import Bowser from 'bowser';
import { updateLocation } from './location';
import { getLocationByIP } from './ipLocation';
import { variablesBySessionStorage } from './storagesInstantlyVariables';
import {
  EN_DEFAULT_CODE,
  EN_DEFAULT_ISO,
  FR_DEFAULT_CODE,
  FR_DEFAULT_ISO,
  FR_MOCK,
} from './config';
import translationsUI from '~/view/ui/translationUI';

export const userAgentDetect = () => {
  const userAgent = navigator.userAgent;
  console.log(userAgent)
  console.log(Bowser.parse(userAgent))
  return Bowser.parse(userAgent);
};

export const getUID = () => {
  var navigator_info = window.navigator;
  var screen_info = window.screen;
  var uid = navigator_info.mimeTypes.length;
  uid += navigator_info.userAgent.replace(/\D+/g, '');
  uid += navigator_info.plugins.length;
  uid += screen_info.height || '';
  uid += screen_info.width || '';
  uid += screen_info.pixelDepth || '';
  return uid;
};

export const getUserInfomation = (
  browserUserInfo,
  sessionID,
  detectDevice,
  appVersion
) => {
  const height = window.screen.availHeight;
  const width = window.screen.availWidth;
  return {
    phone_number: '',
    session_key: sessionID,
    device_id: `${!!browserUserInfo && browserUserInfo.uID}:${appVersion}`,
    browser: `${!!detectDevice && detectDevice.browserName} ${
      !!detectDevice && detectDevice.fullBrowserVersion
    }`,
    os: ` ${!!detectDevice && detectDevice.osName} ${
      !!detectDevice && detectDevice.osVersion
    }`,
    device: `${!!detectDevice && detectDevice.mobileVendor} ${
      !!detectDevice && detectDevice.mobileModel
    }`,
    ua: `${!!detectDevice && detectDevice.getUA}`,
    resolution: width && height && `${width}x${height}`,
  };
};

export const navigatorUser = (sessionID) => {
  let location_data = [];
  if ('geolocation' in navigator) {
    navigator.geolocation.getCurrentPosition(
      function success(position) {
        const locationFrom = 'gg';
        !!position &&
          !!position.coords.latitude &&
          !!position.coords.longitude &&
          updateLocation(
            sessionID,
            position.coords.latitude,
            position.coords.longitude,
            locationFrom
          );
        window.hasLocation = true;
      },
      function error() {
        getLocationByIP()
          .then((response) => {
            location_data = !!response && response.data;
          })
          .finally(() => {
            const from = 'ipAddress';
            !!location_data &&
              !!location_data.latitude &&
              !!location_data.longitude &&
              updateLocation(
                sessionID,
                location_data.latitude,
                location_data.longitude,
                from,
                location_data.ip || null
              );
            window.hasLocation = true;
            variablesBySessionStorage('SET', 'HSAIP', true);
          });
      }
    );
  } else {
    getLocationByIP()
      .then((response) => {
        location_data = response.data;
      })
      .finally(() => {
        const from = 'ipAddress';
        !!location_data &&
          !!location_data.latitude &&
          !!location_data.longitude &&
          updateLocation(
            sessionID,
            location_data.latitude,
            location_data.longitude,
            from,
            location_data.ip || null
          );
        window.hasLocation = true;
      });
  }
};

export const getBrowserLanguage = () => {
  const language =
    (navigator.languages && navigator.languages[0]) || // Chrome / Firefox
    navigator.language || // All browsers
    navigator.userLanguage; // IE <= 10

  return language;
};

const langsTemp = [
  { iso: 'en', language_code: 'en', label: 'English' },
  { iso: 'en-GB', language_code: 'en_gb', label: 'United Kingdom' },
  { iso: 'fr', language_code: 'fr', label: 'French (Canada)' },
  { iso: 'fr-fr', language_code: 'fr_fr', label: 'French' },
  { iso: 'de', language_code: 'de', label: 'German' },
  { iso: 'it', language_code: 'it', label: 'Italian' },
  { iso: 'es', language_code: 'es', label: 'Spanish' },
  { iso: 'es-MX', language_code: 'es_mx', label: 'Spanish (Mexico)' },
  { iso: 'pt-BR', language_code: 'pt_br', label: 'Portuguese (Brazil)' },
  { iso: 'nl', language_code: 'nl', label: 'Dutch' },
];

export const languageResolver = async (langs, params, actions, intl) => {
  const langDevice = getBrowserLanguage();

  const mapLabel = langs.map((lang) => ({
    iso: lang.iso,
    language_code: lang.language_code,
    label: lang.label ? lang.label : lang.iso,
  }));

  const addingDeviceLang = [
    ...mapLabel,
    {
      iso: langDevice,
      language_code: langDevice.substring(0, 2),
      label: `${intl.formatMessage(translationsUI.DEVICE_LANGUAGE)}`,
    },
  ];
  const { changeLangList, getUrlParams, deviceLocale } = actions;
  await changeLangList(addingDeviceLang);

  // Priority to check device lang > api setting > first item in lang list
  const hasLangByDevice = langsTemp.find((lang) =>
    lang.iso.toLowerCase().includes(langDevice.substring(0, 2))
  );
  deviceLocale(langDevice);
  if (hasLangByDevice) {
    return {
      localeObj: {
        code: {
          iso: hasLangByDevice.iso,
          language_code: hasLangByDevice.language_code,
        },
        active: hasLangByDevice.language_code,
      },
      settingObj: {
        lang_code: hasLangByDevice.language_code,
        iso: hasLangByDevice.iso,
      },
    };
  } else if (params && params.lang && params.lang.length > 0) {
    getUrlParams(params);
    const urlLang = params.lang;
    const foundLang = langs.find(
      ({ language_code }) => urlLang === language_code
    );
    if (foundLang) {
      return {
        localeObj: {
          code: {
            iso: foundLang.iso,
            language_code: foundLang.language_code,
          },
          active: foundLang.language_code,
        },
        settingObj: {
          lang_code: foundLang.language_code,
          iso: foundLang.iso,
        },
      };
    } else {
      if (FR_MOCK.includes(urlLang)) {
        const language_code = FR_DEFAULT_CODE;

        return {
          localeObj: {
            code: {
              iso: FR_DEFAULT_ISO,
              language_code: language_code,
            },
            active: language_code,
          },
          settingObj: {
            lang_code: language_code,
            iso: FR_DEFAULT_ISO,
          },
        };
      } else {
        const language_code = EN_DEFAULT_CODE;
        return {
          localeObj: {
            code: {
              iso: EN_DEFAULT_ISO,
              language_code: language_code,
            },
            active: language_code,
          },
          settingObj: {
            lang_code: language_code,
            iso: EN_DEFAULT_ISO,
          },
        };
      }
    }
  } else {
    const getDefault = langs[0];

    return {
      localeObj: {
        code: {
          iso: getDefault.iso,
          language_code: getDefault.language_code,
        },
        active: getDefault.language_code,
      },
      settingObj: {
        lang_code: getDefault.language_code,
        iso: getDefault.iso,
      },
    };
  }
};
